import React, { useState } from "react";
import { FaShieldAlt, FaEdit, FaSave, FaCity, FaBuilding, FaMapMarkerAlt } from "react-icons/fa";
import Navbar from "../Components/Navbar";
import { toast } from "react-toastify";

const SubadminAccess = () => {
  const [plans, setPlans] = useState([
    { id: 1, name: "Plan 1 - Basic", units: "", icon: FaBuilding },
    { id: 2, name: "Plan 2 - Standard", units: "", icon: FaCity },
    { id: 3, name: "Plan 3 - Premium", units: "", icon: FaMapMarkerAlt },
  ]);

  const handleUpdate = (id) => {
    toast.success("Plan updated successfully");
  };

  const handleInputChange = (id, value) => {
    setPlans(plans.map(plan => 
      plan.id === id ? { ...plan, units: value } : plan
    ));
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 pt-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto py-8">
          {/* Header Section */}
          <div className="bg-white rounded-2xl shadow-lg p-6 mb-6 border border-gray-100">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-lg">
                <FaShieldAlt className="text-white text-xl" />
              </div>
              <div>
                <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  Subadmin Access Management
                </h1>
                <p className="text-gray-500 text-sm mt-1">Configure access plans for subadmins</p>
              </div>
            </div>
          </div>

          {/* Plans Section */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <div className="p-6 border-b border-gray-100">
              <h2 className="text-xl font-semibold text-gray-800">Access Plans Configuration</h2>
              <p className="text-gray-500 text-sm mt-1">Manage and configure access plans for different regions</p>
            </div>

            <div className="p-6 space-y-6">
              {plans.map((plan) => {
                const Icon = plan.icon;
                return (
                  <div 
                    key={plan.id}
                    className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-6 border border-gray-200 hover:shadow-md transition-all duration-300"
                  >
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-md">
                          <Icon className="text-white" size={20} />
                        </div>
                        <div>
                          <h3 className="text-lg font-semibold text-gray-800">{plan.name}</h3>
                          <p className="text-gray-500 text-sm">Configure access units</p>
                        </div>
                      </div>

                      <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                        <div className="relative">
                          <input
                            type="text"
                            placeholder="Enter units"
                            value={plan.units}
                            onChange={(e) => handleInputChange(plan.id, e.target.value)}
                            className="w-full sm:w-48 px-4 py-2.5 rounded-xl border-2 border-gray-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-200 outline-none text-gray-700 placeholder-gray-400"
                          />
                        </div>
                        <button
                          onClick={() => handleUpdate(plan.id)}
                          className="inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
                        >
                          <FaSave size={14} />
                          <span>Update</span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Info Section */}
            <div className="p-6 bg-gradient-to-r from-blue-50 to-purple-50 border-t border-gray-200">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <FaEdit className="text-white" size={14} />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1">Configuration Tips</h4>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Enter the number of access units for each plan</li>
                    <li>• Click Update to save changes for each plan individually</li>
                    <li>• Units determine the access level for subadmins</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubadminAccess;
